import { Progress } from 'antd';
import CustomTitle from '../../../../components/CustomTitle';

type Props = {
    step: number;
}

export default function TitleProgressbar({ step }: Props) {
  return (
    <>
        <CustomTitle
        title={STEPS[step].title}
        description={STEPS[step].description}
      />

      <div className="grid grid-cols-12">
        <div className="col-span-8">
          <Progress
            percent={((step + 1) / STEPS.length) * 100}
            showInfo={false}
            strokeColor="#f97316"
            trailColor="rgba(3, 2, 19, 0.2)"
            strokeWidth={8}
            className="w-full"
          />
        </div>
      </div>

      <div className="justify-start text-slate-700 text-sm font-normal mt-1 mb-6">
        Step {step + 1} of {STEPS.length}
      </div>
    </>
  )
}

export const STEPS = [
    {
      title: "General Course Information",
      description: "This information will appear publicly on your course page.",
    },
    {
      title: "Course Highlights",
      description: "This information will appear publicly on your course page.",
    },
    {
        title: "Course Curriculums",
        description: "This information will appear publicly on your course page.",
      },
    // {
    //   title: "Course Curriculums",
    //   description: "This information will appear publicly on your course page.",
    // },
    // {
    //   title: "Course Quality Checklist",
    //   description: "Make sure your course meets all quality standards.",
    // },
 
  ];